export const CALCULATOR_TEMPLATE = `
  <section class="gc-npc-tool" aria-labelledby="gc-npc-tool-title">
    <header class="gc-npc-tool__head">
      <div>
        <p>GamerCubic coordinate tool</p>
        <h2 id="gc-npc-tool-title">Link Your Nether Portals</h2>
      </div>
      <button class="gc-npc-reset" id="gc-npc-reset" type="button">Reset</button>
    </header>

    <div class="gc-npc-editions" role="group" aria-label="Minecraft edition">
      <button type="button" data-edition="java" aria-pressed="true"><span>Java Edition</span><small>16-block Nether search</small></button>
      <button type="button" data-edition="bedrock" aria-pressed="false"><span>Bedrock Edition</span><small>128-block Nether search</small></button>
    </div>

    <div class="gc-npc-converter">
      <section class="gc-npc-dimension gc-npc-dimension--overworld" aria-labelledby="gc-npc-overworld-title">
        <div class="gc-npc-dimension__title"><div><span>01</span><h3 id="gc-npc-overworld-title">Overworld</h3></div><strong>Scale 1×</strong></div>
        <div class="gc-npc-fields">
          <label for="gc-npc-overworld-x"><span>X</span><input id="gc-npc-overworld-x" data-dimension="overworld" data-axis="x" inputmode="decimal" autocomplete="off" spellcheck="false"></label>
          <label for="gc-npc-overworld-y"><span>Y</span><input id="gc-npc-overworld-y" data-dimension="overworld" data-axis="y" inputmode="decimal" autocomplete="off" spellcheck="false"></label>
          <label for="gc-npc-overworld-z"><span>Z</span><input id="gc-npc-overworld-z" data-dimension="overworld" data-axis="z" inputmode="decimal" autocomplete="off" spellcheck="false"></label>
        </div>
        <button class="gc-npc-copy-coords" type="button" data-copy-coords="overworld">Copy XYZ</button>
        <div class="gc-npc-command">
          <span>Teleport command</span>
          <code id="gc-npc-overworld-command"></code>
          <button type="button" data-copy-command="overworld">Copy</button>
        </div>
      </section>

      <div class="gc-npc-ratio" aria-label="Overworld X and Z divide by eight to reach the Nether. Nether X and Z multiply by eight to reach the Overworld. Y stays unchanged.">
        <strong><span>÷ 8</span><i aria-hidden="true">→</i></strong>
        <small>Y unchanged</small>
        <strong><i aria-hidden="true">←</i><span>× 8</span></strong>
      </div>

      <section class="gc-npc-dimension gc-npc-dimension--nether" aria-labelledby="gc-npc-nether-title">
        <div class="gc-npc-dimension__title"><div><span>02</span><h3 id="gc-npc-nether-title">The Nether</h3></div><strong>Scale 8×</strong></div>
        <div class="gc-npc-fields">
          <label for="gc-npc-nether-x"><span>X</span><input id="gc-npc-nether-x" data-dimension="nether" data-axis="x" inputmode="decimal" autocomplete="off" spellcheck="false"></label>
          <label for="gc-npc-nether-y"><span>Y</span><input id="gc-npc-nether-y" data-dimension="nether" data-axis="y" inputmode="decimal" autocomplete="off" spellcheck="false"></label>
          <label for="gc-npc-nether-z"><span>Z</span><input id="gc-npc-nether-z" data-dimension="nether" data-axis="z" inputmode="decimal" autocomplete="off" spellcheck="false"></label>
        </div>
        <button class="gc-npc-copy-coords" type="button" data-copy-coords="nether">Copy XYZ</button>
        <div class="gc-npc-command">
          <span>Teleport command</span>
          <code id="gc-npc-nether-command"></code>
          <button type="button" data-copy-command="nether">Copy</button>
        </div>
      </section>
    </div>

    <div class="gc-npc-status" aria-live="polite">
      <div><span class="gc-npc-status__dot" aria-hidden="true"></span><p id="gc-npc-rule-note"></p></div>
      <p id="gc-npc-height-note"></p>
      <span class="gc-npc-copy-status" id="gc-npc-copy-status"></span>
    </div>

    <section class="gc-npc-maps" aria-labelledby="gc-npc-map-title">
      <div class="gc-npc-maps__head">
        <div><span>03</span><div><p>Portal linking visualizer</p><h3 id="gc-npc-map-title">Portal Search Range Map</h3></div></div>
        <button type="button" id="gc-npc-clear-portal" disabled>Clear existing portal</button>
      </div>
      <p class="gc-npc-map-help">Both views cover the same physical region. X increases right, Z increases down. Click either map to place an existing portal.</p>
      <div class="gc-npc-map-grid">
        <figure class="gc-npc-map-card">
          <figcaption><div><strong>Overworld</strong><span id="gc-npc-overworld-center"></span></div><small>2,560 blocks across</small></figcaption>
          <canvas id="gc-npc-overworld-map" width="640" height="640" tabindex="0" role="img"></canvas>
          <p id="gc-npc-overworld-summary" class="gc-npc-map-summary"></p>
        </figure>
        <figure class="gc-npc-map-card gc-npc-map-card--nether">
          <figcaption><div><strong>The Nether</strong><span id="gc-npc-nether-center"></span></div><small>320 blocks across</small></figcaption>
          <canvas id="gc-npc-nether-map" width="640" height="640" tabindex="0" role="img"></canvas>
          <p id="gc-npc-nether-summary" class="gc-npc-map-summary"></p>
        </figure>
      </div>
      <div class="gc-npc-legend" aria-label="Map legend">
        <span><i class="gc-npc-legend__position" aria-hidden="true"></i>Your position</span>
        <span><i class="gc-npc-legend__range" aria-hidden="true"></i>Portal search range</span>
        <span><i class="gc-npc-legend__portal" aria-hidden="true"></i>Existing portal</span>
      </div>
      <div class="gc-npc-capture" id="gc-npc-capture" aria-live="polite">
        <strong>No existing portal placed</strong><span>Click either map to check whether another portal could capture the link.</span>
      </div>
    </section>
  </section>
`;
